// extracted by mini-css-extract-plugin
module.exports = {"fullLayout":"_1m8wJxOFALOv3CPfzru8zt"};